import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useAuthenticationFlows from "@/account/composables/use-authentication-flows";


export default /*@__PURE__*/_defineComponent({
  __name: 'navigation-buttons-unauthenticated',
  setup(__props) {

const { openLoginModal, openRegistrationModal } = useAuthenticationFlows();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      class: "user-menu__link-create-account",
      "data-testid": "create-account-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openRegistrationModal) && _unref(openRegistrationModal)(...args)))
    }, " Vytvořit účet "),
    _createElementVNode("button", {
      type: "button",
      class: "btn user-menu__btn-login",
      "data-testid": "login-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openLoginModal) && _unref(openLoginModal)(...args)))
    }, " Přihlásit ")
  ]))
}
}

})